(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["original-paintings"] && !Shopify.designMode) return;
  try {
    
function initializePaintingFilm() {
  document.querySelectorAll('.cold-film').forEach(function(video) {
    if (video.dataset.initialized) return;
    video.dataset.initialized = 'true';
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!motion.matches) video.play().catch(function() {});
    motion.addEventListener('change', function(event) {
      if (event.matches) video.pause();
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializePaintingFilm);
} else {
  initializePaintingFilm();
}
document.addEventListener('shopify:section:load', initializePaintingFilm);

  } catch(e) { console.error(e); }
})();
})();
